import React, { useEffect, useState } from 'react';

/** <img>, das geschützte Bilder mit Bearer-Token lädt (kein Token in der URL). */
export const AuthImg = ({ src, alt = '', onError, ...rest }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let objectUrl = null;
    let cancelled = false;
    setUrl(null);
    fetch(src, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => { if (!r.ok) throw new Error(String(r.status)); return r.blob(); })
      .then(b => { if (!cancelled) { objectUrl = URL.createObjectURL(b); setUrl(objectUrl); } })
      .catch(e => { if (!cancelled) onError?.(e); });
    return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [src]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!url) return <span data-testid="auth-img-loading" className="inline-block w-full h-full" aria-busy="true" />;
  return <img src={url} alt={alt} {...rest} />;
};
